// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/tema-bdbn/index.less
// module id = 17
// module chunks = 25